const TYPES = {
  AuthHandler: Symbol.for('AuthHandler'),
  SessionHandler: Symbol.for('SessionHandler'),
  AuthService: Symbol.for('AuthService'),
  ApiService: Symbol.for('ApiService'),
  ConvoService: Symbol.for('ConvoService'),
  PostService: Symbol.for('PostService'),
  CommentService: Symbol.for('CommentService'),
  StatementService: Symbol.for('StatementService'),
  UserService: Symbol.for('UserService'),
  AuthContainer: Symbol.for('AuthContainer'),
  IConfig: Symbol.for('IConfig'),
  IAuth0Config: Symbol.for('IAuth0Config'),
  WebAuthContainer: Symbol.for('WebAuthContainer'),
  App: Symbol.for('App')
}

export default TYPES
